import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { BotRunListStore } from "../../store/BotRunListStore";
import { BotRunListForm } from "./BotRunListForm";
import { BotRunListDialogs } from "./BotRunListDialogs";
import { ListToolbox } from "../../../../common/controls";
import { useStore } from "../../../../hooks";

export const BotRunListPage = observer(() => {
  const rootStore = useRootStore();
  const { langStore } = rootStore;
  const path = "/botRun/list";

  const store = useStore(path, () => new BotRunListStore(rootStore));

  const cancelProcess: (() => void) | undefined = undefined;

  const listToolbox = (
    <ListToolbox
      paginatorProps={{
        page: store.currentPage,
        totalRows: store.totalRows,
        rowsPerPage: store.pageSize,
        hasNextPage: store.hasNextPage,
        onPageChange: (newPage: number) => store.onPageChange(newPage),
        onPageSizeChange: (pageSize: number) =>
          store.onPageSizeChange(pageSize),
      }}
      processing={store.status === "fetching" || store.status === "processing"}
      cancelProcess={cancelProcess}
      showColumnFilters={store.grid.showColumnFilters}
      onToggleFilters={() => store.grid.toggleShowColumnFilters()}
      filtersLabel={`${langStore.filtersCommand}`}
      isFullScreen={store.grid.isFullScreen}
      onToggleFullScreen={() => store.grid.toggleIsFullScreen()}
      viewMode={store.grid.viewMode}
      onToggleViewMode={() => {
        store.grid.toggleViewMode();
        store.saveProfile();
      }}
      columnsLabel={`${langStore.columnsCommand}`}
      columns={store.grid.columnMenuItems}
      columnVisibility={store.grid.mrtColumnVisibility}
      onColumnVisibilityChange={(visibility) =>
        store.grid.setMrtColumnVisibility(visibility)
      }
      columnOrder={store.grid.columnOrder}
      onColumnOrderChange={(order) => store.grid.setColumnOrder(order)}
      onResetColumnOrder={() => store.grid.resetColumnOrder()}
      onShowAllColumns={() => store.grid.showAllColumns()}
      onHideAllColumns={() => store.grid.hideAllColumns()}
      onSaveFormat={() => store.saveProfile()}
      language={langStore.language as "es" | "en" | "pt"}
      enableMultiSelect={store.isActionEnabled("delete")}
      multiSelectMode={store.multiSelectMode}
      onToggleMultiSelect={() => store.toggleMultiSelectMode()}
      selectedCount={store.selectedRowIds.size}
      onSelectAllPage={() => store.selectAllPage()}
      onClearSelection={() => store.clearSelection()}
      onMultiDelete={() => store.openMultiDeleteDialog()}
      multiSelectLabel={langStore.multiSelectButton}
      selectedCountLabel={langStore.selectedCount(store.selectedRowIds.size)}
      multiDeleteLabel={langStore.multiDeleteButton}
      cancelSelectionLabel={langStore.multiSelectCancel}
    />
  );

  return (
    <div>
      <PageLayout secondaryToolbox={listToolbox}>
        <BotRunListForm listStore={store} />
      </PageLayout>
      <BotRunListDialogs store={store} />
    </div>
  );
});
